import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { throwError } from 'rxjs';

import { EmployeesService } from '../../../services/employees/employees.service';

@Component({
  selector: 'app-form-contato-colab',
  templateUrl: './infos-contato-colab.component.html',
  styleUrls: ['./infos-contato-colab.component.scss']
})
export class InfosContatoColabUpdateComponent implements OnInit {
  @Input() infos: any;
  @Input() colaboradorRef: any;

  @Output() reload: EventEmitter<boolean> = new EventEmitter<boolean>();

  formDadosColaborador: FormGroup;
  phoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  submittingForm: boolean;

  constructor(private fb: FormBuilder, private employeesService: EmployeesService) {}

  ngOnInit(): void {
    this.createForm();
    this.loadInfos();
  }

  createForm(): void {
    this.formDadosColaborador = this.fb.group({
      id: [this.infos?.id],
      department: [this.infos?.department],
      role: [this.infos?.role],
      unit: [this.infos?.unit],
      salary: this.fb.group({
        value: ['']
      }),
      email: [''],
      phone_number: this.fb.group({
        country_code: '55',
        number: ['']
      })
    });
  }

  loadInfos(): void {
    if (this.infos !== null && typeof this.infos !== 'undefined') {
      this.formDadosColaborador.get('phone_number.number').setValue(this.infos?.phone);
      this.formDadosColaborador.get('email').setValue(this.infos?.email);
    }
  }

  submitForm(form: FormGroup): void {
    const formValue = form.value;
    this.submittingForm = true;

    const data = {
      id: this.infos?.id,
      name: this.infos?.name,
      email: formValue.email,
      birthDate: formValue.birthDate,
      role: null,
      department: null,
      unit: null,
      phone: formValue.phone_number.number,
      employeeCode: this.infos?.admission?.employeeCode,
      admission: {
        id: this.infos?.admission?.id,
        organizationID: this.infos?.admission?.organizationID,
        date: this.infos?.admission?.date
      }
    };
    this.employeesService.updateEmployee(data).subscribe(
      () => (this.reload.emit(true), (this.submittingForm = false)),
      err => {
        this.reload.emit(true), throwError(err);
      }
    );
  }

  /**
   * Cancel form editing action by reseting form, loading the original information and closing the edition view
   */
  cancel($event: Event): void {
    this.formDadosColaborador.reset();
    this.loadInfos();
    this.colaboradorRef.deactiveEdit($event);
  }
}
